import { tidy } from '@aera/ui';
import { useEffect, useRef } from 'react';

export const INTERSTITIAL_MS = 1500;

/** Time to read the sentence: 120 ms a character, at least INTERSTITIAL_MS and at most six seconds. */
export const interstitialMs = (text: string): number => Math.max(INTERSTITIAL_MS, Math.min(6000, 120 * [...text].length));

/** One sentence between modules ("三分之一了，接下来聊聊理想的样子"); no button, it moves on by itself or on a tap. */
export function Interstitial({ text, onDone }: { text: string; onDone: () => void }) {
  const done = useRef(onDone);
  done.current = onDone;
  useEffect(() => {
    const id = setTimeout(() => done.current(), interstitialMs(text));
    return () => clearTimeout(id);
  }, [text]);
  return (
    <main className="mx-auto flex min-h-[70svh] w-full max-w-[640px] cursor-default items-center px-6" onClick={() => done.current()} aria-live="polite">
      <p className="lp-display text-[clamp(1.6rem,6vw,2.3rem)] text-ink">{tidy(text)}</p>
    </main>
  );
}
